import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Location = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '15px'}
      height={size || '15px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 15 15"
      fill={color || 'currentColor'}
    >
      <path
        d="M2.13254 11.0116L2.12587 11.0184L1.83943 10.6743C0.836392 9.46942 0.166992 8.14258 0.166992 6.48275C0.166992 3.17889 2.77836 0.5 6.00033 0.5C9.22232 0.5 11.8337 3.17889 11.8337 6.48275C11.8337 8.14392 11.1057 9.57533 10.1539 10.6825L5.99841 15.4984L2.13254 11.0116ZM6.00033 1.33333C3.22803 1.33333 0.9801 3.63852 0.9801 6.48275C0.9801 7.85133 1.51038 8.97367 2.39755 10.0602L5.99883 14.2399L9.54383 10.1316C10.4071 9.12742 11.0206 7.88383 11.0206 6.48275C11.0206 3.63852 8.77266 1.33333 6.00033 1.33333ZM2.96922 6.48C2.96922 4.76437 4.32628 3.37353 6.00032 3.37353C7.67432 3.37353 9.0314 4.76437 9.0314 6.48C9.0314 8.19567 7.67432 9.5865 6.00032 9.5865C4.32628 9.5865 2.96922 8.19567 2.96922 6.48ZM6.00032 4.20687C4.77532 4.20687 3.78233 5.2246 3.78233 6.48C3.78233 7.7355 4.77532 8.75317 6.00032 8.75317C7.22523 8.75317 8.21832 7.7355 8.21832 6.48C8.21832 5.2246 7.22523 4.20687 6.00032 4.20687Z"
        fill="#242323"
      />
    </StyledSvg>
  );
};
